import { isValidElement } from 'react';
import styled from 'styled-components';
import { Typography } from 'components/generic/typography';
import format from 'helpers/translations';

/* #region  styles */
const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: auto;
`;

export interface IXSmallTooltipContent {
    description: string;
}
/* #endregion */

export default function SmallTooltipPopupContent({ content }: { content: IXSmallTooltipContent }) {
    const { description } = content;

    return (
        <Content>
            <Typography.Body size="S" forwardedAs="span">
                {isValidElement(description) ? description : format(description)}
            </Typography.Body>
        </Content>
    );
}
